interface ReleaseCardAccessibilityInput {
  catalogNumberCount: number;
  index: boolean;
  labelCount: number;
  releaseId: string;
  title: string;
}

export interface ReleaseCardAccessibility {
  ariaDescribedBy: string | undefined;
  ariaLabel: string | undefined;
  ariaLabelledBy: string | undefined;
  catalogNumberId: string | undefined;
  headingId: string | undefined;
  labelId: string | undefined;
}

export function releaseCardAccessibility(
  input: ReleaseCardAccessibilityInput,
): ReleaseCardAccessibility {
  if (!input.index) {
    return {
      ariaDescribedBy: undefined,
      ariaLabel: input.title,
      ariaLabelledBy: undefined,
      catalogNumberId: undefined,
      headingId: undefined,
      labelId: undefined,
    };
  }

  const idPrefix = `release-card-${input.releaseId}`;
  const headingId = `${idPrefix}-heading`;
  const labelId = input.labelCount > 0 ? `${idPrefix}-label` : undefined;
  const catalogNumberId = input.catalogNumberCount > 0 ? `${idPrefix}-catalog-number` : undefined;
  const ariaDescribedBy = [labelId, catalogNumberId].filter(Boolean).join(" ") || undefined;

  return {
    ariaDescribedBy,
    ariaLabel: undefined,
    ariaLabelledBy: headingId,
    catalogNumberId,
    headingId,
    labelId,
  };
}
